import { render, staticRenderFns } from "./CommonFormWithRoleEditor.vue?vue&type=template&id=b4d29ff6&lang=pug&"
import script from "./CommonFormWithRoleEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithRoleEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithRoleEditor.vue?vue&type=style&index=0&id=b4d29ff6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports